<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer004">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer005">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB2.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="Copyright-heading">Copyright © D. Ferris Arfaa 2024</p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other non-commercial uses permitted by copyright law. For permission requests, write to the publisher.</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Any person who commits any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-2">Ordering Information</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-1">Quantity sales: Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the publisher at the address below.</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-2">Publisher’s Cataloging-in-Publication data</span></p>
<p class="Normal ParaOverride-3">Arfaa, D. Ferris</p>
<p class="Normal ParaOverride-3">The Gift of God’s Word</p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">ISBN </span><span class="CharOverride-3">9781638299356 </span><span class="CharOverride-1">(Paperback)</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-1">ISBN </span><span class="CharOverride-3">9781638299363</span><span class="CharOverride-1"> (ePub e-book)</span></p>
<p class="Normal ParaOverride-4"><span class="CharOverride-4" lang="en-GB" xml:lang="en-GB">Library of Congress Control Number: 2024900369</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">www.austinmacauley.com/us</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">First Published 2024</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-1">Austin Macauley Publishers LLC</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-1">40 Wall Street, 33rd Floor, Suite 3302 </span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-1">New York, NY 10005</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-1">USA</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">mail-usa@austinmacauley.com</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-1">+1 (646) 5125767</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer007">
<p class="dedications">To You</p>
<p class="Normal ParaOverride-5"><span class="CharOverride-5">“The human body has many parts, but the many parts make up one whole body. So it is with the body of Christ. Some of us are Jews, some are Gentiles, some are slaves, and some are free. But we have all been baptized into one body by one Spirit, and we all share the same Spirit.”</span></p>
<p class="Normal ParaOverride-5"><span class="CharOverride-5">– 1 Corinthians 12:12-13</span></p>
<p class="Normal ParaOverride-5"><span class="CharOverride-5">“Have compassion on me, Lord, for I am weak. Heal me, Lord, for my bones are in agony. I am sick at heart. How long, O Lord, until you restore me?”</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer009">
<p class="Graphics"><img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9781638299356_EPUB6.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer010">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB3.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer011">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer012">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer013">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer014">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB5.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer015">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer016">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB7.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer017">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer018">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB8.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer019">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer020">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB9.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer021">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer022">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB10.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer023">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer024">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB11.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer025">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer026">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB12.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer027">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer028">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB13.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer029">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer030">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB14.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer031">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer032">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB15.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer033">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer034">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB16.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer035">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer036">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB17.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer037">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer038">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer039">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB18.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer040">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer041">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB19.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer042">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer043">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB20.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer044">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer045">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB21.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer046">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer047">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB22.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer048">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer049">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB23.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer050">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer051">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB24.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer052">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer053">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB25.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer054">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer055">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB26.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer056">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer057">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB27.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer058">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer059">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB28.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer060">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer061">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB29.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer062">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer063">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB30.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer064">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer065">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB31.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer066">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer067">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB32.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer068">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer069">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB33.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer070">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer071">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB34.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer072">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer073">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB35.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer074">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer075">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB36.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer076">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer077">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB37.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer078">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer079">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB38.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer080">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer081">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB39.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer082">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer083">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB40.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer084">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer085">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB41.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer086">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer087">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB42.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer088">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer089">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB43.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer090">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer091">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB44.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer092">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer093">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB45.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer094">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer095">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB46.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer096">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer097">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB47.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer098">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer099">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB48.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer100">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer101">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB49.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer102">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer103">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB50.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer104">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer105">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB51.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer106">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer107">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB52.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer108">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer109">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB53.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer110">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer111">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB54.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer112">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer113">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB55.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer114">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer115">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB56.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer116">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer117">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB57.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer118">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer119">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB58.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer120">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer121">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB59.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer122">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer123">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB60.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer124">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer125">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB61.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer126">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer127">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB62.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer128">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer129">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB63.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer130">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer131">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB64.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer132">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer133">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB65.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer134">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer135">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB66.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer136">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer137">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB67.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer138">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer139">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB68.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer140">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer141">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB69.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer142">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer143">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB70.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer144">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer145">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB71.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer146">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer147">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB72.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer148">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer149">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB73.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer150">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer151">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB74.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer152">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer153">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB75.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer154">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB76.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer155">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer156">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB77.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer157">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer158">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB78.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer159">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer160">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB79.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer161">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer162">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB80.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer163">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer164">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB81.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer165">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer166">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB82.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer167">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer168">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB83.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer169">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer170">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB84.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer171">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer172">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB85.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer173">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer174">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB86.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer175">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer176">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB87.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer177">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer178">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB88.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer179">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer180">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB89.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer181">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer182">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781638299356_EPUB90.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer183">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NEW_EPUB.vue?61081464